import React, { createContext, useContext } from 'react';
import i18n from 'i18next';

// Create the context
const LanguageContext = createContext();

// LanguageProvider component
export const LanguageProvider = ({ children }) => {
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <LanguageContext.Provider value={{ changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook to use the context
export const useLanguage = () => useContext(LanguageContext);
